(function () {
  "use strict";

  function init() {
    const productJson = document.querySelector("[data-product-json]");
    if (!productJson) return;

    let product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {
      return;
    }

    const genderIdx = product.options.findIndex(
      (o) => o.toLowerCase() === "gender"
    );
    if (genderIdx === -1) return;

    const genderFieldset = document.querySelector(
      '[data-variant-option][data-variant-option-index="' + genderIdx + '"]'
    );
    const switcher = document.querySelector(
      "[data-size-chart-gender-switcher]"
    );
    if (!genderFieldset || !switcher) return;

    const formRadios = genderFieldset.querySelectorAll(
      "[data-variant-option-value]"
    );
    const switcherBtns = switcher.querySelectorAll(
      "[data-size-chart-gender-value]"
    );

    let isSyncing = false;

    // Switcher button → update product form radio
    switcher.addEventListener("click", function (e) {
      const btn = e.target.closest("[data-size-chart-gender-value]");
      if (!btn || isSyncing) return;

      const value = btn.dataset.sizeChartGenderValue;
      const targetRadio = Array.from(formRadios).find((r) => r.value === value);
      if (!targetRadio || targetRadio.checked) {
        updateSwitcherActive(value);
        return;
      }

      isSyncing = true;
      targetRadio.checked = true;
      targetRadio.dispatchEvent(new Event("change", { bubbles: true }));
      updateSwitcherActive(value);
      isSyncing = false;
    });

    // Product form radio → update switcher button state
    genderFieldset.addEventListener("change", function (e) {
      if (isSyncing) return;
      const radio = e.target.closest("[data-variant-option-value]");
      if (!radio || !radio.checked) return;
      updateSwitcherActive(radio.value);
    });

    function updateSwitcherActive(value) {
      switcherBtns.forEach(function (b) {
        b.classList.toggle(
          "is-active",
          b.dataset.sizeChartGenderValue === value
        );
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
